import { forwardRef } from 'react'
import CheckBox from 'components/form/CheckBox'
import { equalTo, not } from 'utils'
import PropTypes from 'prop-types'

const ColumnGroup = forwardRef(({ preset, columns, onChange }, ref) => (
  <>
    <strong className="tit_row" ref={ref}>
      <CheckBox
        label={preset.displayName}
        checked={preset.columns.every(column => columns.find(equalTo(column)))}
        onCheckedChange={checked =>
          onChange(
            checked
              ? columns.concat(
                  preset.columns.filter(
                    column => !columns.find(equalTo(column))
                  )
                )
              : columns.filter(column => !preset.columns.some(equalTo(column)))
          )
        }
      />
    </strong>
    <ul className="list_itemrow">
      {preset.columns.map(column => (
        <li key={column.name}>
          <CheckBox
            label={column.displayName}
            checked={columns.some(equalTo(column))}
            onCheckedChange={checked =>
              onChange(
                checked
                  ? columns.concat(column)
                  : columns.filter(not(equalTo(column)))
              )
            }
          />
        </li>
      ))}
    </ul>
  </>
))

ColumnGroup.displayName = 'ColumnGroup'
ColumnGroup.propTypes = {
  columns: PropTypes.array,
  onChange: PropTypes.func,
  preset: PropTypes.object,
}

export default ColumnGroup
